import Styles from "./ItemUsage.module.scss";
import clsx from "clsx";
import { useCallback, useMemo, useState } from "react";
import PaginationComponent from "../../../Share/Component/Pagination";
import TableComponent from "../../../Share/Component/Table";
import {
  ITEM_USAGE_FAKE_DATA,
  // ITEM_USAGE_PAGE_TITLE,
  ITEM_USAGE_TABLE_COLUMNS,
} from "../../../Constants/itemUsage";
import { formatDate, formatNumber } from "../../../Utils/index";

const PAGE_SIZE = 5;

function AdminItemUsage() {
  const [search, setSearch] = useState("");
  const [keyword, setKeyword] = useState("");
  const [pageIndex, setPageIndex] = useState(0);

  const filteredItems = useMemo(() => {
    const normalizedKeyword = keyword.trim().toLowerCase();

    if (!normalizedKeyword) return ITEM_USAGE_FAKE_DATA;

    return ITEM_USAGE_FAKE_DATA.filter((item) =>
      [
        item.Account,
        item.CharacterId,
        item.Item,
        String(item.Server),
        String(item.Price),
      ]
        .join(" ")
        .toLowerCase()
        .includes(normalizedKeyword)
    );
  }, [keyword]);

  const totalPages = Math.ceil(filteredItems.length / PAGE_SIZE);
  const safePageIndex = totalPages ? Math.min(pageIndex, totalPages - 1) : 0;

  const items = useMemo(() => {
    const start = safePageIndex * PAGE_SIZE;

    return filteredItems.slice(start, start + PAGE_SIZE);
  }, [filteredItems, safePageIndex]);

  const paging = useMemo(
    () => ({
      next: safePageIndex < totalPages - 1,
      previous: safePageIndex > 0,
      totalPages,
      pageIndex: safePageIndex,
    }),
    [safePageIndex, totalPages]
  );

  const handleSearch = useCallback(() => {
    setKeyword(search);
    setPageIndex(0);
  }, [search]);

  const handleChangePage = useCallback((value) => {
    setPageIndex(value);
  }, []);

  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
        <div className={clsx(Styles.bodyMainTop)}>
          <div className={clsx(Styles.filterWrap)}>
            <div className={clsx(Styles.searchWrap)}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className={clsx(Styles.Search)}
              />
              <span
                onClick={handleSearch}
                className={clsx(Styles.contentSearch)}
              >
                Search
              </span>
            </div>
          </div>
        </div>
        <div className={clsx(Styles.table)} id="style-3">
          <TableComponent
            data={items}
            header={ITEM_USAGE_TABLE_COLUMNS}
            customFormatters={{
              Price: formatNumber,
              CreatedDate: formatDate,
            }}
          />
        </div>
        <div className={clsx(Styles.footer)}>
          <div className={clsx(Styles.footerWrap)}>
            <PaginationComponent
              page={paging}
              handleCallApi={handleChangePage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminItemUsage;
